import React, { Component } from 'react';

// コンポーネント読み込み
import Prefectures from '../components/Prefectures'
import VisitedSpotList from '../components/VisitedSpotList'

// データ読み込み
import spotListData from '../WikiData'

// 文字列>ブーリアン 変換
function str2bool(string) {
  if (string === 'true') {
    return true
  } else {
    return false
  }
}

class MyPage extends Component {
  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      selectedSpot: null,
      visitedSpotList: null,
    }
    this.setSelectedSpot = this.setSelectedSpot.bind(this)
    this.setVisitedSpotList = this.setVisitedSpotList.bind(this)
  }

  componentDidMount() {
    this.setVisitedSpotList(spotListData)
  }

  setVisitedSpotList(spotList) {
    let visitedSpotList = []
    for (let i=0; i < spotList.length; i++) {
      if (str2bool(localStorage.getItem(spotList[i].key))) {
        visitedSpotList.push(spotList[i])
      }
    }
    this.setState({ visitedSpotList: visitedSpotList})
  }

  setSelectedSpot(spot) {
    this.setState({selectedSpot: spot})
  }

  render() {
    return (
      <div className="MyPage">
        <div className="MyPage-VisitedSpotList">
          <div className="MyPage-title">
            訪問したことのある観光スポット
          </div>
          <VisitedSpotList spotList={this.state.visitedSpotList} setSelectedSpot={this.setSelectedSpot}/>
        </div>
        <div className="MyPage-Prefectures">
          <div className="MyPage-title">
            都道府県別進行度
          </div>
          <Prefectures />
        </div>
      </div>
    );
  }
}

export default MyPage;
